export enum SideBlocksTabs {
  Quotas,
  Conditions,
  Settings
}
